import React from 'react';
import styles from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      crafted with care · mradul kapoor · {new Date().getFullYear()}
    </footer>
  );
}
